import { render, staticRenderFns } from "./Baccarat1Cart.vue?vue&type=template&id=39fea473&scoped=true"
import script from "./Baccarat1Cart.vue?vue&type=script&lang=js"
export * from "./Baccarat1Cart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fea473",
  null
  
)

export default component.exports